<template>
  <div>
    <v-text-field
      v-model="search"
      class="search-input"
      label="Поиск"
      single-line
      color="accent"
      hide-details
      @keypress.enter="searchRound"
    >
      <template #append-outer>
        <v-icon class="icon" style="font-size: 18px" @click="searchRound">fas fa-check</v-icon>
        <v-icon class="icon" @click="cancelSearch">fas fa-times</v-icon>
      </template>
    </v-text-field>
    <paginated-table
      :items="searchRounds.length === 0 ? items : searchRounds"
      :headers="headers"
      :loading="loading"
      :pullFunction="pull"
    >
      <template #items="props">
        <GameStatisticsItem :item="props.item" />
      </template>
    </paginated-table>
  </div>
</template>

<script>
import GameStatisticsItem from './GameStatisticsItem'
import { getStatisticsRounds } from '../../../../../api/wheel'

export default {
  name: 'GameStatisticsTable',
  components: { GameStatisticsItem },
  props: {
    items: Array,
    pullFunction: Function
  },
  data () {
    return {
      searchRounds: [],
      search: '',
      loading: false,
      pagination: {
        sortBy: 'timestart',
        descending: true
      },
      headers: [
        { text: 'id Раунда', value: 'id' },
        { text: 'Дата и время', value: 'time_start' },
        { text: 'Кол-во игроков', value: 'count_player' },
        { text: 'Сектор 1', value: '' },
        { text: 'Сектор 2', value: '' },
        { text: 'Сектор 5', value: '' },
        { text: 'Сектор 10', value: '' },
        { text: 'Сектор 20', value: '' },
        { text: 'Сектор 40', value: '' },
        { text: 'Результат', value: 'win_sector.value.value' },
        { text: 'Итог для казино', value: 'total' }
      ]
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  methods: {
    searchRound () {
      getStatisticsRounds({
        limit: 25, offset: 0, round_id: +this.search
      }).then(response => {
        this.searchRounds = response.data
        if (this.searchRounds.length === 0)
          this.$store.dispatch('showErrorMessage', 'Раунд не найден')
      })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('showErrorMessage', 'Ошибка')
        })
    },
    cancelSearch () {
      this.search = ''
      this.searchRounds = []
    },
    async pull (page) {
      this.loading = true
      await this.pullFunction(page)
      this.loading = false
    }
  }
}
</script>

<style scoped>
    .icon {
        cursor: pointer;
        font-size: 20px;
        padding: 2px 4px;
    }

    .icon:hover {
        background: #eeeef4;
        border-radius: 4px;
    }

    .search-input {
        flex: none;
        width: 30%;
        margin-left: auto;
        margin-bottom: 10px;
    }
</style>
